/** Preserves row height for aligned Before/After metrics with no value on this side. */
export default function OptLogSnapshotBlankMetricLine() {
  return <span className="block min-h-[20px] shrink-0" aria-hidden />;
}
